import { render, staticRenderFns } from "./PaymentsPricingPage.vue?vue&type=template&id=5189f915&"
import script from "./PaymentsPricingPage.vue?vue&type=script&lang=js&"
export * from "./PaymentsPricingPage.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsPricingPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports